import { Translate } from '@chipinside/translate'
import Button from '@mui/material/Button'
import MuiDialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import { inRange, isEmpty } from 'lodash'

import { Dialog } from '#/components/Dialog'
import { CircularLoader } from '#/components/Loader/Circular'
import LinearLoader from '#/components/Loader/Linear'
import { ResponseContent } from '#/components/Modal/ResponseDialog/content'

function ResponseModal(props) {
  const { content, loading, open } = props

  return (
    <MuiDialog open={open} fullWidth maxWidth="sm">
      {loading ? (
        <CircularLoader minHeight={180} containerStyle={{ marginBottom: 28, marginTop: 28 }} />
      ) : (
        content
      )}
    </MuiDialog>
  )
}

export default function ResponseDialog(props) {
  const {
    afterSuccess,
    autoClose = true,
    code,
    data,
    error,
    loading,
    onClose,
    onConflictActions,
    onFailureActions,
    onSuccessActions,
    open,
  } = props

  const handleClose = () => {
    onClose?.()
    if (inRange(code, 200, 299)) {
      afterSuccess?.()
      Dialog.close()
    }
  }

  const message = error?.message ?? data?.message
  const onConflictButtons = onConflictActions?.()
  const onSuccessButtons = onSuccessActions?.()
  const onFailureButtons = onFailureActions?.()

  return (
    <ResponseModal
      open={open}
      loading={loading}
      content={
        <>
          <ResponseContent code={code} message={message} details={error?.details} />
          {open && inRange(code, 200, 299) && (
            <LinearLoader
              loading
              absolute
              autoClose={autoClose}
              onClose={handleClose}
              /**
               * Fornecendo um tempo de delay maior quando um botão de sucesso é fornecido.
               */
              delay={isEmpty(onSuccessButtons) ? 5000 : 3000}
            />
          )}
          <DialogActions>
            <Button onClick={handleClose} variant="outlined" color="secondary">
              {Translate({ messageKey: 'close' })}
            </Button>
            {onSuccessButtons?.map(render => render({ onClick: handleClose }))}
            {onConflictButtons?.map(render => render())}
            {onFailureButtons?.map(render => render())}
          </DialogActions>
        </>
      }
    />
  )
}
